import useActor from "./useActor";
import { trackEvent } from "../analytics";
import { EventName, Xapi } from "../types/xapi";
import { useCallback } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

function useTracking<T extends object>(): [typeof trackEvent<T>] {
  const [actor, _SetActor] = useActor();
  const userContext: any = useSelector(
    (state: RootState) => state?.xapiSlice?.userContext
  );

  const track = useCallback(
    (
      eventName: EventName,
      data: Xapi,
      options?: unknown,
      callback?: (...params: unknown[]) => unknown
    ) => {
      const { verb } = data;
      const { "en-US": en_us, ...rest } = verb.display;
      const modifiedVerb = {
        ...verb,
        display: {
          ...rest,
          en_US: verb?.display?.["en-US"]
        }
      } as unknown as Xapi["verb"];

      const mergedStatement: Xapi = {
        ...{
          ...data,
          verb: modifiedVerb
        },
        actor: {
          ...data?.actor,
          ...actor
        },
        timestamp: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
        context: userContext
      };
      trackEvent(eventName, mergedStatement, options, callback);
    },
    [actor, userContext]
  );

  return [track];
}

export default useTracking;
